import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var PayoutCalculationIA = function PayoutCalculationIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "GoibG8",
    defaultMessage: [{
      "type": 0,
      "value": "Os pagamentos emitidos às marcas na Faire são calculados através da seguinte fórmula: montante do pagamento = (subtotal da encomenda) + (reembolso do custo de envio) - (comissão) - (taxa de processamento de pagamentos)"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "UVFpLi",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Subtotal da encomenda"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": a soma dos preços para revendedor dos artigos da encomenda, menos quaisquer promoções financiadas pela marca."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "EZKlAY",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Reembolso do custo de envio"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": o custo de envio (aplicável apenas quando a encomenda é processada por conta própria e não com a opção Enviar com a Faire)"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "AWOZxu",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Comissão"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": subtotal da encomenda multiplicado pela taxa de comissão aplicada à encomenda"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "zNePjD",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Taxa de processamento de pagamentos"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": subtotal dos artigos multiplicado pela taxa de processamento de pagamentos"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "H3tdjk",
    defaultMessage: [{
      "type": 0,
      "value": "Pode aceder ao separador "
    }, {
      "children": [{
        "type": 0,
        "value": "Encomendas"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " e clicar na página de detalhes da encomenda para consultar o cálculo completo do seu pagamento. Deslize para baixo até à secção "
    }, {
      "children": [{
        "type": 0,
        "value": "Recebeu um pagamento!e "
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " selecione "
    }, {
      "children": [{
        "type": 0,
        "value": "Ver resumo do pagamento"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ". Aí encontrará um cálculo detalhado do pagamento."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};